import axios from "axios";
import { APP_DATA } from "../data";

export const tessaCitrusApi = axios.create({
    baseURL: APP_DATA.apiUrl,
    withCredentials: true,
});
